import Vue from 'vue';
import {Loading} from 'element-ui'
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
let loading = null;
const showLoading = (params) => {
    if(loading) {
        loading.close();
    }
    let options = {
        fullscreen: false,
        target: document.querySelector('.el-table'),
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
    }
    Object.assign(
        options,
        params
    )
    loading = Loading.service(options);
}
const hideLoading = () => {
    loading.close();
}
export {
    showLoading,
    hideLoading
}



// WEBPACK FOOTER //
// ./src/utils/loading.js